import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import { useOutletContext, useParams } from "react-router-dom";

import ReactSelect from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import { ProductAction } from 'src/actions/product.action';

import numeral from 'numeral';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    MAXIMUM_IMAGES,
} from 'src/utils/constants';

import { Helmet } from "react-helmet";

import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";

import CustomSlider3 from '../CustomSlider3';

import iconMobifone from "../../assets/images/icon_mobifone.png";
import iconVinaphone from "../../assets/images/icon_vinaphone.png";
import iconViettel from "../../assets/images/icon_viettel.png";
import logoNhaMang from "../../assets/images/logo_mang.svg";
import { LocationAction } from 'src/actions/location.action';
import ProductOrderDialog from './ProductOrderDialog';
import ProductPrice2 from '../product-detail/ProductPrice2';
import CustomThumbnailBar from '../CustomThumbnailBar';
import CustomThumbnailBar1 from '../CustomThumbnailBar1';

const TheHomepageProductOne = ({ product }) => {
    const maximumImages = MAXIMUM_IMAGES;
    const ctx = useOutletContext();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const curentPriceIndex = queryParams.get("priceIndex");
    const { itemId } = useParams();
    const { homepageProductSelected } = useSelector(state => state.product)
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);
    const [name, setName] = useState("");
    const [image, setImage] = useState("");
    const [price, setPrice] = useState("");
    const [price_new, setPriceNew] = useState("");
    const [operator, setOperator] = useState("");
    const [operator1, setOperator1] = useState("");
    const [time_by_month, setTimeByMonth] = useState("");
    const [description, setDescription] = useState("");
    const [short_description, setShortDescription] = useState("");
    const [tinh_trang, setTinhTrang] = useState("");
    const [tinh_trang_color, setTinhTrangColor] = useState("");
    const [images, setImages] = useState([]);
    const [prices, setPrices] = useState([]);
    const { isLoading } = useSelector(state => state.app);
    const [open, setOpen] = useState(false);
    const [current, setCurrent] = useState(0);
    const [selectedColor, setSelectedColor] = useState("");
    const [activeTab, setActiveTab] = useState("general_infos");

    const danhSachLoaiSim = SIM_TYPE_LIST_OBJ;

    const tabs = [
        {
            id: "general_infos",
            label: "THÔNG TIN CHUNG",
            icon: (
                <svg width="18" height="18" fill="var(--main-color)" viewBox="0 0 24 24">
                    <path d="M10 16.5l6-4.5-6-4.5v9z" />
                    <path d="M21 3H3a2 2 0 0 0-2 2v14a2 
                    2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 
                    2 0 0 0-2-2zM3 19V5h18v14H3z" />
                </svg>
            ),
        },
        {
            id: "specs",
            label: "THÔNG SỐ KỸ THUẬT",
            icon: (
                <svg width="18" height="18" fill="var(--main-color)" viewBox="0 0 24 24">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 
                    9.24l-7.19-.61L12 2 9.19 8.63 
                    2 9.24l5.46 4.73L5.82 21z" />
                </svg>
            ),
        },
    ];

    const handleSelect = (index) => {
        setCurrent(index);
        setSelectedColor(images[index].color_name ?? "?");
    };

    useEffect(() => {
        console.log(itemId);
        dispatch(ProductAction.homepageFindOne(itemId));
    }, [itemId])

    useEffect(() => {
        console.log(homepageProductSelected);

        setName('');
        setImage('');
        setPrice('');
        setPriceNew('');
        setOperator('');
        setTimeByMonth('');
        setDescription('');
        setShortDescription('');
        setTinhTrang('');
        setTinhTrangColor('');
        setImages([]);
        setPrices([]);

        if (homepageProductSelected) {
            setName(homepageProductSelected.name ? homepageProductSelected.name : '');
            setImage(homepageProductSelected.image ? homepageProductSelected.image : '');
            setPrice(homepageProductSelected.price ? Number(homepageProductSelected.price) : '0');
            setPriceNew(homepageProductSelected.price_new ? Number(homepageProductSelected.price_new) : '0');
            setOperator(homepageProductSelected.operator)
            setOperator1(homepageProductSelected.operator == "MOBIFONE" ? "-160px 3px" : (homepageProductSelected.operator == "VINAPHONE" ? "-80px 3px" : "0px 3px"))
            setTimeByMonth(homepageProductSelected.time_by_month ? numeral(homepageProductSelected.time_by_month).format('0,0') + ' tháng' : '0 tháng');
            setDescription(homepageProductSelected.description ? homepageProductSelected.description : '');
            setShortDescription(homepageProductSelected.short_description ? homepageProductSelected.short_description : '');
            
            setTinhTrang(homepageProductSelected.trang_thai == 'con_hang' ? 'Còn hàng' : (homepageProductSelected.trang_thai == 'giu_so' ? '' : 'Hết hàng'))
            setTinhTrangColor(homepageProductSelected.trang_thai == 'con_hang' ? 'green' : (homepageProductSelected.trang_thai == 'giu_so' ? 'orange' : 'red'))

            let _images = [];

            if (homepageProductSelected.images && homepageProductSelected.images.length > 0) {
                _images = [...homepageProductSelected.images].sort((a, b) => a.index - b.index);
            }

            setImages(_images);

            let _prices = [];

            if (homepageProductSelected.prices && homepageProductSelected.prices.length > 0) {
                _prices = [...homepageProductSelected.prices].sort((a, b) => a.index - b.index);
            }

            setPrices(_prices);
            
            async function fetchData() {
                try {
                    let getProvinces = await dispatch(LocationAction.getProvinces());
                    console.log(getProvinces);
                    setProvinces(getProvinces);
                } catch (error) {
                    console.error(error);
                }
            }

            fetchData();
        }
    }, [homepageProductSelected])

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        province: "-99",
        province_name: "",
        district: "-99",
        district_name: "",
        ward: "-99",
        ward_name: "",
        address: "",
        note: "",
        paymentMethod: "cod",
        quantity: 1,
        itemId,
    });

    useEffect(() => {
        async function fetchData() {
            try {
                setFormData({ 
                    ...formData, 
                    ward: "-99", 
                    ward_name: "", 
                });
                setWards([]);
                let getWards = await dispatch(LocationAction.getWardsByDistrict(formData.district));
                console.log(getWards);
                setWards(getWards);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [formData.province, formData.district])

    useEffect(() => {
        async function fetchData() {
            try {
                setFormData({ 
                    ...formData, 
                    district: "-99",
                    district_name: "", 
                });
                setDistricts([]);
                let getDistricts = await dispatch(LocationAction.getDistrictsByProvince(formData.province));
                console.log(getDistricts);
                setDistricts(getDistricts);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [formData.province])

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleChange1 = (key, value, key1 = null, value1 = null) => {
        if (key1 && value1) {
            setFormData({ 
                ...formData, 
                [key]: value,
                [key1]: value1,
            });
        } else {
            setFormData({ 
                ...formData, 
                [key]: value 
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(ProductAction.sendOrder(formData));
    };

    const datHang = (id) => {
        // dispatch(ProductAction.homepageFindOne(id));
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handlePriceChange = (productId, priceIndex) => {
        console.log(productId, ' || ', priceIndex);

        // Gán giá trị mặc định
        queryParams.set("priceIndex", priceIndex);

        // Cập nhật URL mà không reload trang
        navigate({
            pathname: location.pathname,
            search: `?${queryParams.toString()}`
        }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
    }

    return (<>
        <Helmet>
            <title>{name} | Xe điện SH - Xe điện Song Đan</title>
        </Helmet>

        {isLoading && <div className='loading'></div>}

        {!isLoading && <div style={{ margin: "25px 0", padding: "20px", borderRadius: "10px", background: "var(--background-color)" }}>
            {name && <>
                <div className='product-one-detail-container' style={{ 
                    display: "flex", 
                    justifyContent: "space-between", 
                    // alignItems: "center", 
                    padding: "20px 0 20px 0", 
                    background: "transparent", 
                    borderRadius: "10px" 
                }}>
                    {/* <CustomSlider3 className="product-one-banner" banners={images} showSlideCount={1} showPrevBtn={1} showNextBtn={1} /> */}
                    
                    {/* Slider */}
                    <CustomSlider3
                        className="product-one-banner"
                        banners={images}
                        current={current}
                        setCurrent={setCurrent}
                        showSlideCount={1}
                        showPrevBtn={1}
                        showNextBtn={1}
                    />
                    
                    <div className='product-one-detail' style={{ display: "block", gridTemplateColumns: "100px auto", gap: "10px", padding: "0 0 0 20px", alignItems: 'center' }}>
                        <span className='title' style={{color: 'var(--text-color)', fontWeight: '600', padding: "0"}}>{name}</span>
                        <span className='price' style={{color: 'var(--main-color)', fontWeight: '800'}}>
                            {/* {
                                price_new > 0 && price_new < price ? (
                                    <div>
                                        <span style={{ color: "red", fontWeight: "800" }}>{numeral(price_new).format("0,0")}₫</span>
                                        <span className='price-old' style={{ textDecoration: "line-through", color: "#888" }}>{numeral(price).format("0,0")}₫</span>
                                    </div>
                                ) : (
                                    <div>
                                        <span style={{ fontWeight: "800" }}>{numeral(price).format("0,0")}₫</span>
                                    </div>
                                )
                            } */}
                            <ProductPrice2 product={homepageProductSelected} index={curentPriceIndex} onSelectChange={(priceIndex) => handlePriceChange(itemId, priceIndex)} />
                        </span>

                        <div className="product-one-qua-tang-box">
                            <div className="product-one-qua-tang-header">Quà Tặng Kèm</div>
                            <ul className="product-one-qua-tang-list">
                                <li>Tặng nón bảo hiểm chính hãng.</li>
                                <li>Tặng áo mưa cao cấp.</li>
                                <li>Hỗ trợ đăng ký xe qua cổng dịch vụ công.</li>
                                <li>Hỗ trợ trả góp.</li>
                                <li>Bảo hành lên đến 36 tháng.</li>
                            </ul>
                        </div>

                        <div style={{marginTop: 15}} className='show-color-name'>
                            <strong>Màu sắc: </strong><span className="color-name">{selectedColor}</span>
                        </div>

                        {/* Thumbnail bar */}
                        <CustomThumbnailBar1
                            banners={images}
                            current={current}
                            onSelect={handleSelect}
                        />

                        {homepageProductSelected && homepageProductSelected.trang_thai == 'con_hang' ? (
                            <Button className="order-btn" onClick={() => datHang(homepageProductSelected.id)} >
                                Đặt hàng ngay
                            </Button>
                        ) : (
                            <span className='status' style={{ color: tinh_trang_color }}>{tinh_trang}</span>
                        )}
                    </div>

                    <div className='product-one-more' style={{ display: "block", gridTemplateColumns: "100px auto", gap: "10px", padding: "0 0 0 20px", alignItems: 'center' }}>
                        <div className="product-one-more-box">
                            {/* Hotline */}
                            <div className="product-one-more-hotline">
                                <div>HOTLINE ĐẶT HÀNG</div>
                                <div className="product-one-more-hotline-number">
                                    {ctx.hotline}
                                </div>
                            </div>

                            {/* Ảnh chính */}
                            <div className="product-one-more-image">
                                <img
                                    src="/static/logo.png"
                                    alt=""
                                />
                            </div>

                            {/* Danh sách ưu điểm */}
                            <ul className="product-one-more-list">
                                <li>
                                    <span className="product-one-more-icon">
                                        {/* Xe tải giao hàng */}
                                        <svg width="22" height="22" fill="var(--main-color)" viewBox="0 0 24 24">
                                            <path d="M3 7h13v10H3V7zm13 0h3l3 5v5h-6V7zM5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm12 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
                                        </svg>
                                    </span>
                                    Miễn phí giao xe trong nội thành
                                </li>

                                <li>
                                    <span className="product-one-more-icon">
                                        {/* Giấy tờ / hồ sơ */}
                                        <svg width="22" height="22" fill="var(--main-color)" viewBox="0 0 24 24">
                                            <path d="M6 2h9l5 5v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm8 1.5V9h5.5L14 3.5z"/>
                                        </svg>
                                    </span>
                                    Hỗ trợ đăng ký xe qua cổng dịch vụ công
                                </li>

                                <li>
                                    <span className="product-one-more-icon">
                                        {/* Thẻ tín dụng */}
                                        <svg width="22" height="22" fill="var(--main-color)" viewBox="0 0 24 24">
                                            <path d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2H2V6zm0 4h20v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8zm4 5h4v2H6v-2z"/>
                                        </svg>
                                    </span>
                                    Hỗ trợ trả góp
                                </li>

                                <li>
                                    <span className="product-one-more-icon">
                                        {/* Đổi hàng */}
                                        <svg width="22" height="22" fill="var(--main-color)" viewBox="0 0 24 24">
                                            <path d="M12 5V2L8 6l4 4V7c3.3 0 6 2.7 6 6 0 1-.25 1.95-.7 2.77l1.46 1.46A7.93 7.93 0 0 0 20 13c0-4.42-3.58-8-8-8zm-6.76.23A7.93 7.93 0 0 0 4 11c0 4.42 3.58 8 8 8v3l4-4-4-4v3c-3.3 0-6-2.7-6-6 0-1 .25-1.95.7-2.77L5.24 5.23z"/>
                                        </svg>
                                    </span>
                                    Bảo hành lên đến 36 tháng
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="product-one-tab-box">
                    {tabs.map((tab) => (
                        <div
                            key={tab.id}
                            className={`product-one-tab-item ${
                                activeTab === tab.id ? "active" : ""
                            }`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            <span className="product-one-tab-icon">{tab.icon}</span>
                            <span className="product-one-tab-label">{tab.label}</span>
                        </div>
                    ))}
                </div>

                <div className="product-one-tab-content">
                    {activeTab == 'general_infos' && <div>
                        <div className='product-content media-content' style={{padding: "0 0 20px 0"}} dangerouslySetInnerHTML={{ __html: short_description }} />
                    </div>}

                    {activeTab == 'specs' && <div>
                        <div className='product-content media-content' style={{padding: "0 0 20px 0"}} dangerouslySetInnerHTML={{ __html: description }} />
                    </div>}
                </div>
            </>}
            
            {1 < 0 && name && homepageProductSelected && homepageProductSelected.trang_thai == 'con_hang' && <>
                <div style={{color: '#FF0000', fontSize: '24px', fontWeight: '600', padding: "0 0 20px 0"}}>THÔNG TIN ĐẶT HÀNG</div>
                <form className='form-dat-hang' onSubmit={handleSubmit} style={{ display: "grid", gap: "15px", padding: "0" }}>
                    <div>
                        <label>Số lượng <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                        <input type="text" name="quantity" value={formData.quantity} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div>
                    <div>
                        <label>Họ và tên <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                        <input type="text" name="name" value={formData.name} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div>
                    <div>
                        <label>Số điện thoại <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                        <input type="text" name="phone" value={formData.phone} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div>
                    {/* <div>
                        <label>Email <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div> */}
                    <div>
                        <label>Tỉnh/thành:</label>
                        <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                            <ReactSelect
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 37,
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                    }),
                                }}
                                options={[
                                    { code: '-99', name: 'Chọn tỉnh/thành' },
                                    ...provinces
                                ]}
                                getOptionLabel={(item) => `${item.name}`}
                                placeholder={formData.province_name || "Chọn tỉnh/thành..."}
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={formData.province || null}
                                onChange={(newValue) => {
                                    handleChange1('province', newValue.code, 'province_name', newValue.name);
                                }}
                                isSearchable
                            />
                        </div>
                    </div>
                    <div>
                        <label>Quận/huyện:</label>
                        <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                            <ReactSelect
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 37,
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                    }),
                                }}
                                options={[
                                    { code: '-99', name: 'Chọn quận/huyện' },
                                    ...districts
                                ]}
                                getOptionLabel={(item) => `${item.name}`}
                                placeholder={formData.district_name || "Chọn quận/huyện..."}
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={formData.district || null}
                                onChange={(newValue) => {
                                    handleChange1('district', newValue.code, 'district_name', newValue.name);
                                }}
                                isSearchable
                            />
                        </div>
                    </div>
                    <div>
                        <label>Phường/xã:</label>
                        <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                            <ReactSelect
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 37,
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                    }),
                                }}
                                options={[
                                    { code: '-99', name: 'Chọn phường/xã' },
                                    ...wards
                                ]}
                                getOptionLabel={(item) => `${item.name}`}
                                placeholder={formData.ward_name || "Chọn phường/xã..."}
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={formData.ward || null}
                                onChange={(newValue) => {
                                    handleChange1('ward', newValue.code, 'ward_name', newValue.name);
                                }}
                                isSearchable
                            />
                        </div>
                    </div>
                    <div>
                        <label>Địa chỉ chi tiết <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                        <input type="text" name="address" value={formData.address} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div>
                    <div>
                        <label>Ghi chú (nếu có):</label>
                        <input type="text" name="note" value={formData.note} onChange={handleChange} style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div>
                    <div>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <label>
                                <input type="radio" name="paymentMethod" value="cod" checked={formData.paymentMethod === "cod"} onChange={handleChange} /> COD
                            </label>
                            <label>
                                <input type="radio" name="paymentMethod" value="online" checked={formData.paymentMethod === "online"} onChange={handleChange} /> Chuyển khoản
                            </label>
                        </div>
                    </div>
                    <button type="submit" style={{ marginTop: "10px", padding: "10px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "16px", fontWeight: "600", transition: "0.3s" }}
                        onMouseEnter={(e) => e.target.style.background = "var(--main-color)"}
                        onMouseLeave={(e) => e.target.style.background = "var(--main-color)"}>
                        Đặt hàng
                    </button>
                </form>
            </>}
        </div>}
        <ProductOrderDialog open={open} handleClose={handleClose} type={"EDIT"} priceIndex={curentPriceIndex} />
    </>);
};

export default TheHomepageProductOne;